export class ControDeAcesso {
  id_grupo_usuario: number;
  id_usuarios: number;
  id_grupo: number;
  nome: string;
  email: string;
  url: string;
  existeUsuario: boolean = false;
  acessos: Array<PaginaAcesso>;

  constructor() {
    this.acessos = Array<PaginaAcesso>();
  }
}


export class PaginaAcesso {
  id_pagina: number;
  nome: string;
}
